import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import back from "../../../../static/img/back.svg";
import "./styles.css";
import Footer from "../../footer/footer";
import { getDetalleEjercicio } from "../../../../services/deportistaApi";
import { getUserId } from "../../../../services/utilsApi";
import LoadingScreen from "../../../../static/assets/loadingScreen/loadingScreen";

const MovimientoEjercicio = () => {

    const navigate = useNavigate();

    const location = useLocation();

    const [videoUrl, setVideoUrl] = useState('');

    const [loading, setLoading] = useState(true);

    const { id_ejercicio, bloque_numero, bloqueCompleto, selectedDay } = location.state || {};

    useEffect(() => {
        const fetchVideo = async () => {
            try {
                const health = await getUserId();
                const uid = health.data.user_id;
                const response = await getDetalleEjercicio(uid, id_ejercicio);

                if (response.data) {
                    setVideoUrl(response.data.ejercicio.video || 'No video available');
                } else {
                    console.error('Failed to fetch exercise details:', response);
                    setVideoUrl('No video available');
                }
            } catch (error) {
                console.error('Error fetching video URL:', error);
                setVideoUrl('No video available');
            } finally {
                setLoading(false);
            }
        };

        fetchVideo();
    }, [id_ejercicio]);

    const handleBack = (data) => {
        navigate(`/entrenamiento/bloque`, { state: { ...data, selectedDay } });
    };

    // Función para obtener la URL embebida del video de YouTube con controles
    const getYouTubeEmbedUrl = (videoUrl) => {
            const videoIdMatch = videoUrl.match(/(?:https?:\/\/)?(?:www\.)?youtube\.com\/watch\?v=([^&]+)/) ||
                videoUrl.match(/(?:https?:\/\/)?(?:www\.)?youtu\.be\/([^?]+)/);
            return videoIdMatch ? `https://www.youtube.com/embed/${videoIdMatch[1]}?controls=1&enablejsapi=1&playsinline=1` : "";
    };

    // Función para obtener la miniatura del video de YouTube
    const getYouTubeThumbnail = (videoUrl) => {
            const videoIdMatch = videoUrl.match(/(?:https?:\/\/)?(?:www\.)?youtube\.com\/watch\?v=([^&]+)/) ||
                videoUrl.match(/(?:https?:\/\/)?(?:www\.)?youtu\.be\/([^?]+)/);
            return videoIdMatch ? `https://img.youtube.com/vi/${videoIdMatch[1]}/0.jpg` : "";
    };

    if (loading) return <LoadingScreen />;

    return (
        <div className="movimiento-page">
            <div className="movimiento-header">
                <button className="movimiento-back-button" onClick={() => handleBack({bloque_numero, bloqueCompleto})}>
                    <img src={back} alt="Regresar" />
                </button>
                <h1 className="movimiento-title">Movimientos</h1>
            </div>
            <div className="video-ejercicio">
                <div className="video-miniatura">
                    <img src={getYouTubeThumbnail(videoUrl)} alt="Video Thumbnail" className="video-thumbnail" />
                </div>
                <div className="video-container">
                    <iframe className="youtube"
                        src={getYouTubeEmbedUrl(videoUrl)}
                        title="YouTube video player"
                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                        referrerPolicy="strict-origin-when-cross-origin"
                    ></iframe>
            </div>
            </div>
            <Footer activeScreen="entrenamiento" />
        </div>
    );
};

export default MovimientoEjercicio;
